export default "__VITE_ASSET__K3Wmk8dj__"